import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { Slices } from 'ducks/slices';
import { BatchDefinitionsListAPI } from 'ducks/types/api-types';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';

export const getBatchDefinitionsList = createAsyncThunk<BatchDefinitionsListAPI[], number>(
  `${Slices.BATCH_DEFINITION_LIST}/get`,
  async (entity_id, { rejectWithValue }) => {
    try {
      const res: AxiosResponse['data'] = await Andromeda.get(
        `/batch_definitions/${entity_id}/batch_definition_items/list`,
      );
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);
